<template>
    <div class="checkout-content">
        <div class="checkout-item">
            需
            <span v-if="recedeData.Balance > 0">补</span>
            <span v-else>收</span>
            租客：{{Math.abs(recedeData.Balance.toFixed(2))}}元
        </div>
        <div class="checkout-item">
            入住时间：{{recedeData.Expand.checkindate}}
        </div>
        <div class="checkout-item">
            初始电量：{{recedeData.Initpower.toFixed(2)}}度
        </div>
        <div class="checkout-item">
            退房电量：{{recedeData.Lastpower.toFixed(2)}}度
        </div>
        <div class="checkout-item">
            分摊电量：{{recedeData.Apportion.toFixed(2)}}度
        </div>
        <div class="checkout-item">
            总耗电量：{{recedeData.Allpower.toFixed(2)}}度
        </div>
        <div class="checkout-item">
            累计充值：{{allRecharge}}元（线下：{{recedeData.Rechargeline}}，微信：{{recedeData.Rechargewechat}}，支付宝：{{recedeData.Rechargealipay}}，民生银行：{{recedeData.Rechargeminsheng}}）
        </div>
        <div class="checkout-item">
            累计花费：{{recedeData.Settleunpaid.toFixed(2)}}元
        </div>
    </div>
</template>

<script>
    import store from "../store";

    export default {
        name: "Checkout",
        data() {
            return {
                allRecharge: 0,
            }
        },
        computed: {
            recedeData() {
                this.allRecharge = store.state.recedeData.Rechargeline + store.state.recedeData.Rechargewechat + store.state.recedeData.Rechargealipay + store.state.recedeData.Rechargeminsheng;
                return store.state.recedeData;
            }
        }
}
</script>

<style scoped>
    .checkout-item {
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        margin-bottom: 0.15rem;
    }
    .checkout-item-body {
        /*display: flex;*/
        /*flex-wrap: wrap;*/
    }
</style>